import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import colors from '@/plugins/colors';
let ColorMixin = class ColorMixin extends Vue {
    colors = colors;
};
ColorMixin = __decorate([
    Component({})
], ColorMixin);
export default ColorMixin;
